import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadPhotosQueryAtom = createQueryAtomFactory(
  'trade.loadPhotos',
  (params: { id?: string }) => ({
    load: {
      __args: {
        id: params.id ?? '',
      },
      recyclerFiles: {
        id: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
        status: true,
        metadata: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: ({ load }) => load?.recyclerFiles ?? [],
  },
);
